import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as GuiasCompraService from 'services/guiasCompra.service'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Ingreso Guias - Compras',
    path: `/${CodigosTransaccionesConstant.COMPRASINGRESOGUIA_LISTA}`
  },
  {
    name: 'Nueva'
  }
]

const EditarGuia = ({ history, match }) => {
  const [guiaInfo, setGuiaInfo] = React.useState(null)

  React.useEffect(() => {
    GuiasCompraService.getGuia(match.params.idGuia).then(({ data }) => {
      setGuiaInfo(data)
    })
  }, [match.params.idGuia])

  return (
    <>
      {guiaInfo && (
        <Portlet>
          <Portlet.Header title='Ingreso Guias - Compras' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <MainForm history={history} guiaInfo={guiaInfo} />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default EditarGuia
